import React, { useRef } from 'react';
import { Button } from 'fronton-react';
import { useIntersectionObserverCallback } from '@navi-toolbox/hooks';

type ItemProps = {
  children: React.ReactElement;
  className?: string;
  href?: string;
  variant: 'primary' | 'secondary' | 'outline' | 'pseudo';
  as?: React.ElementType;
  data?: { idx: number; elementBlock: string; text: string };
  onItemIntersect?: (idx: number) => void;
  onSendAnalytics: (name?: string) => void;
};

export const CarouselItem: React.FC<ItemProps> = ({
  children,
  className,
  href,
  variant,
  as = 'a',
  data,
  onItemIntersect,
  onSendAnalytics,
}) => {
  const carouselItemRef = useRef<HTMLDivElement | null>(null);
  useIntersectionObserverCallback(carouselItemRef, {
    enter: () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      onItemIntersect && onItemIntersect(data ? data.idx : 0);
    },
    extraUnobserve: 'enter',
  });

  return (
    <Button
      ref={carouselItemRef}
      kind="regular"
      as={as}
      onClick={() => onSendAnalytics(data?.text)}
      variant={variant}
      href={href}
      target="_blank"
      className={className}
      data-qa-carousel-item=""
    >
      {children}
    </Button>
  );
};
